import { cn } from "@/lib/utils";
import { useHasOtherRoleUnread, useUserRoles } from "../hooks/use-user-roles";

/**
 * A dot for the user menu's trigger, shown while a role other than the
 * active one has unread notifications. It loads the role list itself, so the
 * counts are there before the menu is first opened. The parent positions it
 * (it is `absolute`). Decorative: the menu's role rows carry the counts for
 * screen readers.
 */
export function RoleUnreadDot({
	className,
}: {
	className?: string;
}): React.JSX.Element | null {
	useUserRoles();
	const hasUnread = useHasOtherRoleUnread();
	if (!hasUnread) return null;
	return (
		<span
			aria-hidden="true"
			data-testid="role-unread-dot"
			className={cn(
				"pointer-events-none absolute h-2.5 w-2.5 rounded-full bg-dashboard-accent ring-2 ring-dashboard-surface",
				className,
			)}
		/>
	);
}
